var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCable = function SvgCable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 57.875V60c0 18.778 15.222 34 34 34s34-15.222 34-34-15.222-34-34-34h-2.125C40.271 26 26 40.27 26 57.875z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 58.063V60c0 17.12 13.88 31 31 31 17.12 0 31-13.88 31-31 0-17.12-13.88-31-31-31h-1.938C42.013 29 29 42.012 29 58.063z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 58.25V60c0 15.464 12.536 28 28 28s28-12.536 28-28-12.536-28-28-28h-1.75C43.752 32 32 43.752 32 58.25z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58.438V60c0 13.807 11.193 25 25 25s25-11.193 25-25-11.193-25-25-25h-1.563C45.493 35 35 45.493 35 58.438z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58.625V60c0 12.15 9.85 22 22 22s22-9.85 22-22-9.85-22-22-22h-1.375C47.235 38 38 47.234 38 58.625z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 58.813V60c0 10.493 8.507 19 19 19s19-8.507 19-19-8.507-19-19-19h-1.188C48.975 41 41 48.975 41 58.813z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 59v1c0 8.837 7.163 16 16 16s16-7.163 16-16-7.163-16-16-16h-1c-8.284 0-15 6.716-15 15z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59.625V60a6 6 0 106-6h-.375A5.625 5.625 0 0054 59.625z",
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60v45.5",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

export default SvgCable;